export const PRODUCT_SEARCH_HITS_PER_PAGE = 30

export const PRODUCT_SEARCH_RELEVANCY_DESC_KEY = 'relevancy_desc'
export const PRODUCT_SEARCH_TOP_SELLER_COUNT_DESC_KEY = 'topsellerCount_desc'
export const PRODUCT_SEARCH_PRICE_ASC_KEY = 'price_asc'
export const PRODUCT_SEARCH_PRICE_DESC_KEY = 'price_desc'
export const PRODUCT_SEARCH_NEW_ADDED_PRODUCTS_KEY = 'Novelties'

export const PRODUCT_SEARCH_ALGOLIA_SORTING_KEY_ORDER = [
  PRODUCT_SEARCH_RELEVANCY_DESC_KEY,
  PRODUCT_SEARCH_TOP_SELLER_COUNT_DESC_KEY,
  PRODUCT_SEARCH_PRICE_ASC_KEY,
  PRODUCT_SEARCH_PRICE_DESC_KEY,
  PRODUCT_SEARCH_NEW_ADDED_PRODUCTS_KEY,
] as const

export type ProductSearchAlgoliaSortingKey =
  (typeof PRODUCT_SEARCH_ALGOLIA_SORTING_KEY_ORDER)[number]
